import { StylesConfig } from 'react-select';

export const colourStyles: StylesConfig = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: state.isFocused ? '1px solid #EE3F7C !important' : '1px solid rgba(255, 255, 255, 0.07) !important',
      borderRadius: '12px !important',
      minHeight: '46px',
      height: 'auto',
      boxShadow: 'none',
      color: '#ffffff',
      '&:hover': {
        borderColor: 'rgba(238, 63, 124, 0.55) !important',
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: '4px 12px',
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 0.45)',
      fontSize: '14px',
    }),
    singleValue: (styles) => ({
      ...styles,
      color: '#ffffff',
    }),
    input: (styles) => ({
      ...styles,
      color: '#ffffff',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 0.45)',
      ':hover': {
        color: '#ffffff',
      },
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: '#181018',
      border: '1px solid rgba(255, 255, 255, 0.12)',
      borderRadius: '14px',
      zIndex: 99999,
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected
        ? 'rgba(238, 63, 124, 0.3)'
        : isFocused
        ? 'rgba(255, 255, 255, 0.08)'
        : 'transparent',
      color: '#ffffff',
      cursor: 'pointer',
      fontSize: '13px',
    }),
}